// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1SE0_","location":"Header_location__1vRmB"};